module.exports = __webpack_public_path__ + "img/media_gallery.68cca81a.svg";